<template>
  <div class="">
    <div class="row">
      <div class="col-md-12 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <div class="row">
              <div class="col-md-4">
                <input class="form-control pull-right" type="search" placeholder="Search Devices" id="example-search-input" v-model="searchQuery">
              </div>
              <div class="col-md-2">
                <router-link class="btn btn-success" to="/admin/device/create" v-if="org['curOrg']['role'] == 99">Add</router-link>
              </div>
            </div>
            <br/>
            <data-table :data="filteredData" :columns="gridColumns" :filter-key="searchQuery"></data-table>
          </div>
        </div>
      </div><!-- /.col-md-12 -->
    </div>
  </div>
</template>

<script>
import DataTable from './DevicesTable'
import database from '../../webmaster/Database/database'

import store from '../../../components/webmaster/Store/vuex'

export default {
  name: 'devices',
  components: {
    'data-table': DataTable
  },
  data () {
    return {
      searchQuery: '',
      gridColumns: ['name', 'type', 'more'],
      devices: {},
      org: store.state.usermain,
    }
  },
  created:function(){
    //Populate users
    var ref = '/orgs/' + this.$store.state.usermain.curOrg.id + '/devices'
    this.$bindAsObject('devices', database.getRef(ref));

    if (this.org['curOrg']['role'] != 99) {
      this.gridColumns = ['name', 'type'];
    }
  },
  computed: {
    filteredData:function(){
      const data = this.devices;

      Object.keys(data).forEach(function (key) {
        if (key == '.key') {
          delete data[key];
        } else {
          data[key]['.key'] = key;
        }
      })
      
      return data;
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Devices.vue?763a2799